import {css, html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/Button/Button.js'
import '@isceco/widget-library2/basic-elements/Popup/Popup.js'
import WebComponent from '../../WebComponent.js'
import StatusService from "./StatusService";
import {unsafeHTML} from "@isceco/widget-library2/external/lit/development/index.all";
import Monitoring from "../Admin/Monitoring/Monitoring";
import I18n from "../../i18n";

export default class Status extends WebComponent {

  static get EVENT_KEYS() {
    return {
      LAST_MODIFIED: 'status-lastmodified-changed'
    }
  }

  constructor() {
    super()
    this.statusService = new StatusService()
    this.statusFileImport = 'failure'
    this.statusFileImportDetail = ''
    this.statusFach = 'failure'
    this.statusFachDetail = ''
  }

  get css() {
    return css`
      #statusbar {
        position: relative;
        float: right;
        padding-inline: 90px;
      }

      #statusbar #icons {
        padding: var(--isceco-space-300);
        padding-right: 0;
      }

      isceco-popup {
        padding: var(--isceco-space-100);
      }

      .success {
        color: var(--isceco-color-green-500);
      }

      .failure {
        color: var(--isceco-color-red-500);
      }

      .error {
        color: var(--isceco-color-yellow-500);
      }

      .icon {
        font-size: 22px !important;
        margin-left: 10px !important;
      }

      @media (max-width: 991.98px) {
        #statusbar {
          float: left;
          padding-inline: 21px;
        }

        #statusbar #icons {
          padding: var(--isceco-space-200);
        }
      }
    `
  }

  connectedCallback() {
    super.connectedCallback()
    this._refresh = () => {
      this.loadData();
    };

    document.addEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh);
    document.addEventListener(Monitoring.EVENT_KEYS.IMPORT_DONE, this._refresh);
    this.loadData();
  }

  disconnectedCallback() {
    document.removeEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh);
    document.removeEventListener(Monitoring.EVENT_KEYS.IMPORT_DONE, this._refresh);
  }

  loadData() {
    this.id = getNavigationId()

    Promise.all([
      this.statusService.getFileStatus(),
      this.statusService.getFachStatus()
    ])
      .then(([fileStatus, fachStatus]) => {
        this.statusFileImport = fileStatus.fileStatus
        this.statusFileImportDetail = fileStatus.detail
        this.statusFach = fachStatus.fachStatus
        this.statusFachDetail = fachStatus.detail
        this.render()
      })
      .catch(_ => {
        this.statusFileImport = 'error'
        this.statusFach = 'error'
        this.render()
      })
  }

  getTemplate() {
    return html`
      <div id="statusbar">
        <div id="icons">
          <isceco-popup direction="down">
            <i @click="${e => {
              this.goToMonitoring(e)
            }}" slot="wrapper" class="icon database ${this.statusFileImport}"></i>
            <div slot="content">
              ${unsafeHTML(this.statusFileImportDetail)}
            </div>
          </isceco-popup>
          <isceco-popup direction="left">
            <i @click="${e => {
              this.goToMonitoring(e)
            }}" slot="wrapper" class="icon tasks ${this.statusFach}"></i>
            <div slot="content" style="width: ${this.statusFach === "failure" ? '460px' : '300px'}">
              ${unsafeHTML(this.statusFachDetail)}
            </div>
          </isceco-popup>
        </div>
      </div>
    `
  }

  goToMonitoring(event) {
    if (event) {
      event.stopPropagation()
    }
    navigate({to: 'Admin_Monitoring'})
  }
}
customElements.define('gasmonitoring-frontend-status', Status)
